export enum Buildings {
  Living = 1,
  Hospital = 2,
  Children = 4,
  Other = 8,
}

export enum Layouts {
  Default,
  Analytics,
  Dispatcher,
  Login,
}

export enum FilterCondition {
  Equal = 0,
  Greater = 1,
  Less = 2,
  GreaterOrEqual = 3,
  LessOrEqual = 4,
  Like = 5,
  In = 6,
  Between = 7,
  NotEqual = 8,
}

export enum SortingDirection {
  Asc = 0,
  Desc = 1,
}

export enum EventNotificationType {
  Sms = 1,
  Email = 2,
  SmsAndEmail = 0,
}

export enum FormConstructorFieldType {
  Text = 0,
  FloatNumber = 1,
  Number = 2,
  Date = 3,
  Time = 4,
  DateTime = 5,
  Address = 6,
  LinkToUserDictionary = 7,
  LinkToSystemDictionary = 8,
  File = 9,
  Logic = 10,
  Textarea = 11,
  FileArray = 12,
  LinkToForm = 13,
  LinkToOrganization = 14,
  LinkToBuilding = 15,
  Map = 16,
  AutoFillColumn = 17,
  EnumSelect = 100,
  HiddenText = 101,
  IntArray = 150,
}

export enum FormConstructorAutoFillColumnFieldValues {
  UserFullName = 1,
  OrganizationName = 2,
  ShortOrganizationName = 3,
  INN = 5,
  ArithmeticField = 6,
}

export enum ArithmeticOperationType {
  Fraction,
  Difference,
  Amount,
  Percent,
}

export enum FormConstructorBlockType {
  Fields = 1,
  Table = 0,
}

export enum HazardCategory {
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum ObjectsRegisterCategory {
  Default = 0,
  Ownless = 1,
  Categorization = 2,
  SubjectTDestruction = 3,
  Destruction = 4,
  Perspective = 5,
}

export enum ObjectsRegisterListMode {
  List = "list",
  Tree = "tree",
}

export enum FormCompareTypes {
  With = "with",
  To = "to",
}

export enum PermissionAction {
  Чтение = 0,
  Запись = 1,
  Обновление = 2,
  Удаление = 4,
}

export enum TerSubsystemType {
  /// ЭБ на три года
  ThreeYears = 1,

  /// ЭБ на текущий год
  SingleYear = 2,

  /// Корректировочный протокол
  Correction = 3,

  /// Отчет о фактическом потреблении
  Consumption = 4,
  /// Корректировочный_протокол
  CorrectionResult = 5,
  /// Сводный Отчет
  ConsumptionFact = 6,
  ConsumptionFactGRBS = 7,

  ///Протокол согласования лимитов потребления ТЭР и и вода по ГРБС на год
  ProtocolSingleYear = 8,

  /// Справка согласования лимитов
  ActThreeYear = 9
}

export enum TerDocumentType {
  /// Расшифровка
  Form = 1,

  /// Справка организации
  OrganizationAct = 2,

  /// Справка ГРБС
  GrbsAct = 3,

  /// Сводный документ (ЭБ, Свод корректировочных протоколов, Сводный отчет о фактическом потреблении)
  SummaryAct = 4,
}

export enum TerNavConstantsButtons {
  decoding = "Перейти на расшифровку",
  GrbsList = "Перейти к списку учреждений",
  CesList = "Перейти к списку ГРБС",
  ArhiveList = "Архивные документы",
  Subsidy = "Cубсидии",
  SubsidyList = "Список субсидий",
}

export enum GridTypes {
  HeatSupply = 1,
  WaterSupply = 2,
  GasSupply = 3,
  OutdoorLightning = 4,
  WaterDrainage = 5,
  PowerSupply = 6,
  Ventilation = 7,
  Canalization = 8,
  NegativeImpact = 9,
  Coal = 10,
  Masut = 11,
}

export enum UserOrgnaizationTypes {
  Admin = "ADMIN",
  Gu = "GU",
  Ces = "CES",
  Ter = "TER",
  Grbs = "GRBS",
  Keio = "KEIO",
  Rso = "RSO",
}
